/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { PrinterRestService } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { InitDialogViewService } from '@gh/common-shared';

export interface PrinterFinderDialogConfig extends FinderDialogConfig {
}

@Injectable()
export class PrinterFinderBusinessService implements InitDialogViewService<PrinterFinderDialogConfig> {
  constructor(private printerRest: PrinterRestService) {
  }

  initDialogView(): any {
    return this.printerRest.findAllForFinder();
  }
}
